<template>
  <custom-popup
    v-model="dialog"
    :cons="{ title: $t('qrUsersList.customersList') }"
    hide-confirm
    max-width="1024"
    :reloadable="true"
    :persistent="true"
    @close="resetFields"
    :key="$i18n.locale"
    @reload="handleReload"
  >
    <v-card class="pa-4" flat>
      <v-btn
        @click="newUserShow = true"
        outlined
        class="pa-2 btn-get-code rounded-lg"
      >
        <v-icon size="20">mdi-plus</v-icon>
        {{ $t("qrUsersList.addUser") }}
      </v-btn>
      <v-switch
        v-model="userRegister"
        :label="$t('qrUsersList.registerOnline')"
        :color="userRegister ? 'red' : 'green'"
        hide-details
        @change="changeOnlineRegiter"
      ></v-switch>

      <v-divider></v-divider>

      <v-progress-linear v-show="loading" class="mb-2" indeterminate />
      <vue-table
        :data="{ data: users }"
        :headers="usersColumns"
        :loading.sync="loading"
        @change="onPagination"
      >
        <template v-slot:filters="{ props, perPage }">
          <v-row no-gutters>
            <v-col class="pa-2" cols="12" lg="2" md="3">
              <v-select
                v-model="props.length"
                :items="perPage"
                class="rounded-lg"
                dense
                hide-details
                :label="$t('qrUsersList.perPage')"
                outlined
              />
            </v-col>
            <v-col class="pa-2" cols="12" lg="3" md="4">
              <v-text-field
                v-model="props.search"
                append-icon="mdi-magnify"
                class="rounded-lg"
                clearable
                dense
                hide-details
                :label="$t('qrUsersList.search')"
                outlined
              />
            </v-col>
            <!-- <v-col class="pa-2" cols="12" lg="3" md="3">
              <v-autocomplete
                v-model="props.status"
                append-icon="mdi-list-status"
                class="rounded-lg"
                clearable
                :items="statusItems"
                item-text="text"
                item-value="value"
                dense
                :no-data-text="$t('qrUsersList.noStatus')"
                hide-details
                :label="$t('qrUsersList.usersColumns.status')"
                outlined
                @change="onFilterChange('status', $event)"
              >
                <template v-slot:selection="{ item }">
                  <v-icon left small color="primary">{{ item.icon }}</v-icon>
                  {{ item.text }}
                </template>
                <template v-slot:item="{ item }">
                  <v-icon left small color="primary">{{ item.icon }}</v-icon>
                  {{ item.text }}
                </template>
              </v-autocomplete>
            </v-col> -->
            <v-col class="pa-2" cols="12" lg="2" md="3">
              <v-select
                v-model="props.column"
                :items="columnOptions"
                :label="$t('qrUsersList.sortColumn')"
                dense
                outlined
                class="rounded-lg"
                @change="onPagination"
              />
            </v-col>
            <v-col class="pa-2" cols="12" lg="2" md="3">
              <v-select
                v-model="props.dir"
                :items="dirOptions"
                :label="$t('qrUsersList.sortDirection')"
                dense
                outlined
                class="rounded-lg"
                @change="onPagination"
              />
            </v-col>
          </v-row>
        </template>

        <template v-slot:name="{ item }">
          {{ item.name }}
        </template>
        <template v-slot:family="{ item }">
          {{ item.family }}
        </template>
        <template v-slot:mobile="{ item }">
          {{ use_lang(item.mobile.replace("+", "")) || "--" }}
        </template>
        <template v-slot:id="{ item }">
          {{ use_lang(item.id) }}
        </template>
        <template v-slot:orders_count="{ item }">
          {{ use_lang(item.orders_count) }}
        </template>
        <template v-slot:last_login_at="{ item }">
          {{ use_lang(datetime(item.last_login_at, "datetime")) || "--" }}
        </template>
        <template v-slot:disabled="{ item }">
          <v-chip :color="userStatus(item).color" small>
            <v-icon left :color="userStatus(item).color" x-small>
              {{ userStatus(item).icon }}
            </v-icon>
            {{ userStatus(item).text }}
          </v-chip>
        </template>
        <template v-slot:action="{ item }">
          <orders-list-button :data="item" :meta="metabutton" />
        </template>
      </vue-table>

      <custom-popup
        v-model="showOrders"
        :cons="{ title: $t('qrUsersList.orders') }"
        @close="userOrders = []"
        :reloadable="false"
        :persistent="true"
      >
        <v-card class="pa-4" flat>
          <data-table
            :columns="orderColumns"
            :data="{ data: userOrders }"
            :debounce-delay="3000"
            :per-page="[10, 25, 50, 100, 500]"
            :translate="translate"
            class="pt-5 mt-5 table-striped text-center table-hover table-responsive-lg table-responsive-md table-responsive-sm table-responsive-xs"
          />
        </v-card>
      </custom-popup>

      <custom-popup
        v-model="showAddresses"
        :cons="{ title: $t('qrUsersList.addresses') }"
        @close="userAddresses = []"
        :reloadable="false"
        :persistent="true"
      >
        <v-card class="pa-4" flat>
          <data-table
            :columns="addressesColumns"
            :data="{ data: userAddresses }"
            :debounce-delay="3000"
            :per-page="[10, 25, 50, 100, 500]"
            :translate="translate"
            class="pt-5 mt-5 table-striped text-center table-hover table-responsive-lg table-responsive-md table-responsive-sm table-responsive-xs"
          />
        </v-card>
      </custom-popup>
    </v-card>
    <add-user v-model="newUserShow" :info_id="info.id" @user-created="fetch" />
  </custom-popup>
</template>

<script>
import ordersListButton from "@/view/components/adapters/qrList/ordersListButton.vue";
import { dataTableProps } from "@/main";
import { debounce } from "@/custom";
import { mapGetters, mapActions, mapState } from "vuex";
import AddUser from "./addUser.vue";
export default {
  name: "qrUsersList",
  components: { ordersListButton, AddUser },

  props: {
    value: Boolean,
    address: String,
  },

  data() {
    return {
      info: {},
      newUserShow: false,
      users: [],
      tableProps: {
        search: "",
        length: 10,
        column: "id",
        dir: "desc",
        page: 1,
        status: null,
      },
      translate: dataTableProps.translate,
      loading: false,
      showOrders: false,
      userOrders: [],
      showAddresses: false,
      userAddresses: [],
      statusItems: [
        {
          text: this.$t("qrUsersList.status.all"),
          value: null,
          icon: "mdi-filter",
        },
        {
          text: this.$t("qrUsersList.usersColumns.activeUser"),
          value: "active",
          icon: "mdi-check",
        },
        {
          text: this.$t("qrUsersList.usersColumns.none"),
          value: "inactive",
          icon: "mdi-close",
        },
      ],
      columnOptions: [
        { text: this.$t("qrUsersList.usersColumns.id"), value: "id" },
        // { text: this.$t("qrUsersList.usersColumns.name"), value: "name" },
        // { text: this.$t("qrUsersList.usersColumns.family"), value: "family" },
        { text: this.$t("qrUsersList.usersColumns.mobile"), value: "mobile" },
        {
          text: this.$t("qrUsersList.usersColumns.lastLogin"),
          value: "last_login_at",
        },
      ],
      dirOptions: [
        { text: this.$t("qrUsersList.sortDirectionDesc"), value: "desc" },
        { text: this.$t("qrUsersList.sortDirectionAsc"), value: "asc" },
      ],
    };
  },
  computed: {
    ...mapGetters("ribbon", ["user"]),
    ...mapState("local", ["qr_id"]),
    ...mapState("localstorage", ["registerOnline"]),
    userRegister: {
      get() {
        return this.info?.user_register ?? false;
      },
      set(value) {
        this.changeOnlineRegiter(value);
      },
    },
    url() {
      if (typeof this.info === "string") {
        return this.info;
      } else if (typeof this.info === "object" && this.info !== null) {
        return `${this.info.domain?.name}/${this.info.identifier}`.replace(
          /\/+/g,
          "/"
        );
      }
      return "";
    },
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    cons() {
      return {
        title: this.$t("qrUsersList.customersList"),
      };
    },
    metabutton() {
      const buttons = [
        // {
        //   name: "info",
        //   label: this.$t("qrUsersList.usersColumns.buttons.info"),
        //   icon: "account",
        //   class: "btn-outline-success",
        //   action: this.actions,
        // },
        // {
        //   name: "history",
        //   label: this.$t("qrUsersList.usersColumns.buttons.history"),
        //   icon: "clock",
        //   class: "btn-outline-warning",
        //   action: this.actions,
        // },
        {
          name: "addresses",
          label: this.$t("qrUsersList.usersColumns.buttons.addresses"),
          icon: "map-marker",
          class: "btn-outline-danger",
          action: this.actions,
        },
        {
          name: "orders",
          label: this.$t("qrUsersList.usersColumns.buttons.orders"),
          icon: "basket",
          class: "btn-outline-info",
          action: this.actions,
        },

        {
          name: "status",
          label: this.$t("qrUsersList.usersColumns.status"),
          icon: "account-cancel",
          class: "btn-outline-change",
          action: this.actions,
        },
      ];

      if (this.$i18n.locale === "fa") {
        buttons.splice(1, 0, {
          name: "sendSms",
          label: this.$t("qrUsersList.usersColumns.buttons.sendSms"),
          icon: "message-reply-text",
          class: "btn-outline-primary",
          action: this.actions,
        });
      }

      return { buttons };
    },
    usersColumns() {
      const buttons = [
        {
          name: "info",
          label: this.$t("qrUsersList.usersColumns.buttons.info"),
          icon: "account",
          class: "btn-outline-success",
          action: this.actions,
        },
        {
          name: "history",
          label: this.$t("qrUsersList.usersColumns.buttons.history"),
          icon: "clock",
          class: "btn-outline-warning",
          action: this.actions,
        },
        {
          name: "addresses",
          label: this.$t("qrUsersList.usersColumns.buttons.addresses"),
          icon: "map-marker",
          class: "btn-outline-danger",
          action: this.actions,
        },
        {
          name: "orders",
          label: this.$t("qrUsersList.usersColumns.buttons.orders"),
          icon: "basket",
          class: "btn-outline-info",
          action: this.actions,
        },
      ];

      if (this.$i18n.locale === "fa") {
        buttons.splice(1, 0, {
          name: "sendSms",
          label: this.$t("qrUsersList.usersColumns.buttons.sendSms"),
          icon: "message-reply-text",
          class: "btn-outline-primary",
          action: this.actions,
        });
      }

      return [
        {
          value: "name",
          text: this.$t("qrUsersList.usersColumns.name"),
          align: "center",
          sortable: true,
        },
        {
          value: "family",
          text: this.$t("qrUsersList.usersColumns.family"),
          align: "center",
          sortable: true,
        },
        {
          value: "mobile",
          text: this.$t("qrUsersList.usersColumns.mobile"),
          align: "center",
          sortable: true,
        },
        {
          value: "id",
          text: this.$t("qrUsersList.usersColumns.subscriptionId"),
          align: "center",
          sortable: true,
        },
        {
          value: "orders_count",
          text: this.$t("qrUsersList.usersColumns.ordersCount"),
          align: "center",
          sortable: true,
        },
        {
          value: "last_login_at",
          text: this.$t("qrUsersList.usersColumns.lastLogin"),
          align: "center",
          sortable: true,
        },
        {
          value: "disabled",
          text: this.$t("qrUsersList.usersColumns.status"),
          align: "center",
          sortable: false,
        },
        {
          value: "action",
          text: this.$t("qrUsersList.usersColumns.actions"),
          align: "center",
          sortable: false,
          component: ordersListButton,
          event: "actions",
          meta: { buttons },
        },
      ];
    },
    orderColumns() {
      return [
        {
          label: this.$t("qrUsersList.orderColumns.orderId"),
          name: "id",
        },
        {
          label: this.$t("qrUsersList.orderColumns.customerName"),
          name: "user.name",
        },
        {
          label: this.$t("qrUsersList.orderColumns.mobile"),
          name: "user.mobile",
        },
        {
          label: this.$t("qrUsersList.orderColumns.paymentMethod"),
          name: "payment_type",
          transform: ({ data }) => {
            return this.pt(data.payment_type);
          },
        },
        {
          label: this.$t("qrUsersList.orderColumns.shippingMethod"),
          name: "shipping_type",
          transform: ({ data }) => {
            return this.st(data.shipping_type);
          },
        },
        {
          label: this.$t("qrUsersList.orderColumns.orderAmount"),
          name: "price",
          transform: ({ data }) => {
            return (
              this.price(data.price) +
              " " +
              this.$t("qrUsersList.orderColumns.currency")
            );
          },
        },
        {
          label: this.$t("qrUsersList.orderColumns.orderTime"),
          name: "created_at",
          transform: ({ data }) => {
            return this.datetime(data.created_at, "datetime");
          },
        },
        {
          label: this.$t("qrUsersList.orderColumns.status"),
          name: "status",
        },
      ];
    },
    addressesColumns() {
      return [
        {
          label: this.$t("qrUsersList.addressesColumns.id"),
          name: "id",
        },
        {
          label: this.$t("qrUsersList.addressesColumns.addressTitle"),
          name: "title",
        },
        {
          label: this.$t("qrUsersList.addressesColumns.name"),
          name: "name",
        },
        {
          label: this.$t("qrUsersList.addressesColumns.family"),
          name: "family",
        },
        {
          label: this.$t("qrUsersList.addressesColumns.mobile"),
          name: "mobile",
        },
        {
          label: this.$t("qrUsersList.addressesColumns.address"),
          name: "address",
        },
        {
          label: this.$t("qrUsersList.addressesColumns.zipCode"),
          name: "zip_code",
        },
        {
          label: this.$t("qrUsersList.addressesColumns.number"),
          name: "number",
        },
        {
          label: this.$t("qrUsersList.addressesColumns.unit"),
          name: "unit",
        },
      ];
    },
  },

  watch: {
    "$i18n.locale": {
      handler() {
        this.$forceUpdate();
      },
      immediate: true,
      deep: true,
    },
    

    value(val) {
      if (val) {
                this.fetchData().then(() => {
                this.fetch();
              });
      }
    },
  },

  methods: {
    fetchData() {
      this.loading = true;
      console.log(this.address, "qruserslist");
      
      return this.$api
        .get(`/v1/testQr/find/${this.address?.replace('?gateway=true','')}`)
        .then(({ data }) => {
          this.info = data.data;
        })
        .finally(() => (this.loading = false));
    },
        changeOnlineRegiter() {
      // if (typeof this.info === "object" && this.info !== null && this.info.id) {
      this.$api
        .post("v1/testQr/register", {
          qr_id: this.qr_id || this.info.id,
          register: this.registerOnline || (this.info?.user_register ? 1 : 0),
        })
        .then(() => {
          this.$toast.success(
            this.$t("qrUsersList.messages.registerUpdated") ||
              "وضعیت ثبت نام آنلاین به‌روزرسانی شد"
          );
        })
        .catch(() => {
          this.$toast.error(
            this.$t("qrUsersList.messages.registerUpdateError") ||
              "خطا در به‌روزرسانی وضعیت ثبت نام آنلاین"
          );
        });
      // }
    },
    handleReload() {
      this.$nextTick(() => {
        this.fetch();
      });
    },

    fetch(props = this.tableProps) {
      this.loading = true;
      this.$api
        .get(`/v1/testQr/find/users/${this.url}`, {
          params: {
            search: props.search,
            column: props.column,
            dir: props.dir,
            disabled: props.disabled,
          },
        })
        .then(({ data }) => {
          this.users = data.data;
        })
        .catch((err) => {
          this.$toast.error(this.$t("qrUsersList.fetchError"));
        })
        .finally(() => (this.loading = false));
    },
    onPagination(e) {
      if (
        e.page !== this.tableProps.page ||
        e.length !== this.tableProps.length ||
        e.search !== this.tableProps.search ||
        e.disabled !== this.tableProps.disabled ||
        e.column !== this.tableProps.column ||
        e.dir !== this.tableProps.dir
      ) {
        this.tableProps.page = e.page;
        this.tableProps.length = e.length;
        this.tableProps.search = e.search;
        this.tableProps.disabled = e.disabled;
        this.tableProps.column = e.column;
        this.tableProps.dir = e.dir;
        this.$nextTick(() => {
          this.fetch();
        });
      }
    },
    onFilterChange(filter, value) {
      this.tableProps[filter] = value === "" ? null : value;
      this.fetch();
    },
    userStatus(data) {
      const isActive = data.disabled;
      return {
        text:
          isActive === 1
            ? this.$t("qrUsersList.usersColumns.activeUser")
            : this.$t("qrUsersList.usersColumns.none"),
        color: isActive ? "teal-lighten-4" : "red-lighten-4",
        icon: isActive ? "mdi-check" : "mdi-close",
      };
    },
    st(t) {
      switch (t) {
        case "courier":
          return this.$t("qrUsersList.shippingType.courier");
        case "reservation":
          return this.$t("qrUsersList.shippingType.reservation");
        case "place":
          return this.$t("qrUsersList.shippingType.place");
        default:
          return this.$t("qrUsersList.shippingType.none");
      }
    },
    pt(t) {
      return this.$t("qrUsersList.paymentType.online");
    },
    resetFields() {
      this.users = [];
      this.userOrders = [];
      this.userAddresses = [];
      this.tableProps = {
        search: "",
        length: 10,
        column: "id",
        dir: "desc",
        page: 1,
        status: null,
      };
    },
    actions(data, type) {
      this[type + "Action"](data);
    },
    ordersAction(data) {
      this.showOrders = true;
      setTimeout(() => {
        this.userOrders = data.orders;
      }, 300);
    },
    statusAction(data) {
      console.log(data, "check data  for ban");
      this.$api
        .post("v1/testQr/user/ban-unban", {
          user_id: data.id,
          ban: !data.disabled,
        })
        .then(() => {
          this.$toast.success("وضعیت کاربر تغییر کرد");
          this.fetch();
        });
    },
    addressesAction(data) {
      this.showAddresses = true;
      setTimeout(() => {
        this.userAddresses = data.addresses;
      }, 300);
    },
    infoAction(data) {
      this.$toast.info(this.$t("soon"));
      // this.$router.push({ name: "userEdit", params: { id: data.id } });
    },
    historyAction(data) {
      this.$toast.info(this.$t("soon"));
      // this.$router.push({ name: "userHistory", params: { id: data.id } });
    },
    sendSmsAction(data) {
      navigator.clipboard.writeText(data.share_link || this.url);
      this.$toast.success(this.$t("qrOrdersList.linkCopied"));
      let token = localStorage.getItem("id_token");

      let user = this.user?.name ?? "";
      let link = "";

      if (this.user?.family) user += " " + this.user.family;
      if (this.info.domain?.name)
        link = this.info.domain.name + this.info.identifier ?? "";

      let patternId = "";
      switch (this.info.type) {
        case "VisitCard":
          patternId = 244;
          break;
        case "menu":
          patternId = 246;
          break;
        default:
          patternId = 467;
          break;
      }

      let url = `${this.$corepayamakApi}/?token=${token}#/patternSms?link=${link}&pattern=${patternId}&user=${user}`;
      window.open(url, "_blank");
    },
  },
};
</script>

<style scoped>
.teal-lighten-4 {
  background-color: #b2dfdb !important;
  color: #fff !important;
}
.red-lighten-4 {
  background-color: #ffcdd2 !important;
  color: #fff !important;
}
</style>
